<template>
  <div class="max-w-sm mx-auto">
    <div class="bg-white shadow-lg rounded px-4 pt-4 pb-8 m-2 border border-gray-200">
      <p class="text-center font-display text-xl text-pink-400 mb-6">Confirm</p>
      <p class="text-red-700 text-center">Are you sure you want to delete this transaction?</p>
      <div class="pt-6" v-if="transaction">
        <p class="text-center py-2">
          <strong>Amount:</strong>
          <font-awesome-icon
            v-if="inOut === true"
            icon="arrow-alt-circle-down"
            class="ml-2 text-green-400"
          />
          <font-awesome-icon
            v-if="inOut === false"
            icon="arrow-alt-circle-up"
            class="ml-2 text-red-500"
          />
          £{{ transaction.amount }}
        </p>
        <p class="text-center py-2">
          <strong>Date:</strong>
          {{ transaction.date | formatDate }}
        </p>
        <p class="text-center py-2">
          <strong>Notes:</strong>
          {{ transaction.description ? transaction.description : 'N/A' }}
        </p>
        <div class="flex content-center justify-end mt-10">
          <a href="#" class="text-gray-500 px-2 py-1 mr-3" @click.prevent="$router.push('/')">Cancel</a>
          <a
            href="#"
            class="text-white bg-red-500 px-2 py-1 rounded"
            @click.prevent="deleteTransaction"
          >Delete</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "./../store/index";

export default {
  name: "confirm-delete",
  data() {
    return {
      email: null,
      password: null
    };
  },
  props: ["id"],
  methods: {
    deleteTransaction() {
      store.dispatch("deleteTransaction", {
        userId: this.user.id,
        transactionId: this.id
      });
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    transactions() {
      return this.$store.getters.transactions;
    },
    transaction() {
      if (this.transactions.length > 0) {
        return this.transactions.find(obj => obj.id === this.id);
      } else {
        return null;
      }
    },
    inOut() {
      if (this.transaction) {
        return this.transaction.type === "income" ? true : false;
      } else {
        return false;
      }
    }
  },
  watch: {
    user(value) {
      if (value !== null || value !== undefined) {
        this.$router.push("/");
      }
    }
  },
  filters: {
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>